<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tit">Tempestuous</h1>
<h2 class="author">KIM ASKEW and AMY HELMES</h2>
<p class="center"><img alt="Merit Press" height="46" src="OEBPS/images/Merit_Press.gif" width="150"/><br/>
  F+W Media, Inc.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tit.vue?da092098